import { PWA_INSTALL_ENABLED } from '../../config/features.js';
import { useTheme } from '../../hooks/useTheme.js';
import { Icon } from '../Icon/Icon.js';

// Structural in-page anchors (same kind of fixed nav label as the existing
// "Get the app" / #install link below) — not marketing-sourced prose, so
// they live here rather than in a content/*.json file.
const NAV_LINKS = [
  { label: 'Services', href: '#services' },
  { label: 'Team', href: '#team' },
] as const;

export function Header() {
  const { effectiveTheme, toggleTheme } = useTheme();
  const themeIcon = effectiveTheme === 'light' ? 'dark_mode' : 'light_mode';

  return (
    <header
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 20,
        backdropFilter: 'blur(var(--blur)) saturate(150%)',
        WebkitBackdropFilter: 'blur(var(--blur)) saturate(150%)',
        background: 'var(--panel)',
        borderBottom: '1px solid var(--edge)',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '16px',
          padding: '14px clamp(18px,5vw,64px)',
          maxWidth: '1180px',
          margin: '0 auto',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '11px' }}>
          <div
            style={{
              width: '34px',
              height: '34px',
              borderRadius: '10px',
              background: 'var(--yellow)',
              display: 'grid',
              placeItems: 'center',
              flex: 'none',
              boxShadow: 'var(--glowSm)',
            }}
          >
            <svg width="19" height="19" viewBox="0 0 512 512" aria-hidden="true">
              <g fill="#0B72C4">
                <path d="M272 122.67 L441.33 122.67 L381.07 214.67 L211.73 214.67 Z" />
                <path d="M129.33 206.67 L298.67 206.67 L238.4 298.67 L69.07 298.67 Z" />
                <path d="M213.33 296 L382.67 296 L322.4 388 L153.07 388 Z" />
              </g>
            </svg>
          </div>
          <span
            style={{
              font: "800 19px/1 'Plus Jakarta Sans',sans-serif",
              letterSpacing: '-.02em',
              color: 'var(--ink)',
            }}
          >
            CARii
          </span>
        </div>
        <nav class="header-nav" style={{ gap: '26px' }}>
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              style={{
                font: "700 13px/1 'Plus Jakarta Sans',sans-serif",
                color: 'var(--muted)',
              }}
            >
              {link.label}
            </a>
          ))}
        </nav>
        <div style={{ display: 'flex', alignItems: 'center', gap: '9px' }}>
          <button
            type="button"
            onClick={toggleTheme}
            aria-label="Switch theme"
            aria-pressed={effectiveTheme === 'dark'}
            class="glass-hover"
            style={{
              width: '40px',
              height: '40px',
              borderRadius: '999px',
              backdropFilter: 'blur(var(--blur))',
              WebkitBackdropFilter: 'blur(var(--blur))',
              color: 'var(--ink)',
              display: 'grid',
              placeItems: 'center',
              cursor: 'pointer',
            }}
          >
            <Icon name={themeIcon} style={{ fontSize: '20px' }} />
          </button>
          {PWA_INSTALL_ENABLED && (
            <a
              href="#install"
              class="glass-hover"
              style={{
                font: "700 13px/1 'Plus Jakarta Sans',sans-serif",
                color: 'var(--ink)',
                backdropFilter: 'blur(var(--blur))',
                WebkitBackdropFilter: 'blur(var(--blur))',
                padding: '12px 17px',
                borderRadius: '999px',
              }}
            >
              Get the app
            </a>
          )}
        </div>
      </div>
    </header>
  );
}
